import { Radio, RadioGroup } from '@ovComponents/2-component/radio/radio';
import { DepositStarting } from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositSchedule';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { Stack } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

export type DepositEftStartingProp = {
  starting: DepositStarting;
  isInitiatedByRepresentative: boolean;
  allowNow?: boolean;
  allowFutureDate?: boolean;
  onStartingChange: (starting: DepositStarting) => void;
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
};

export const DepositEftStarting = ({
  starting,
  isInitiatedByRepresentative,
  allowNow,
  allowFutureDate,
  onStartingChange,
  onFocus,
  onChange,
}: DepositEftStartingProp) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <RadioGroup
      testId='deposit-form-starting'
      label={t('components:transferModal.starting')}
      sx={{ pb: 0 }}
      value={starting}
      onChange={(e: any) => {
        onStartingChange(e.target.value);
        if (e.target.value === DepositStarting.FutureDate) {
          onFocus('scheduledDate');
        }
        if (e.target.value === DepositStarting.Now) {
          onChange({ scheduledDate: undefined });
        }
      }}
    >
      <Stack direction={'row'}>
        {!isInitiatedByRepresentative && allowNow && (
          <Radio
            testId='deposit-form-starting-now'
            value={DepositStarting.Now}
            label={t('components:transferModal.startingOptions.now')}
          />
        )}
        {allowFutureDate && (
          <Radio
            testId='deposit-form-starting-future'
            value={DepositStarting.FutureDate}
            label={t('components:transferModal.startingOptions.futureDate')}
          />
        )}
      </Stack>
    </RadioGroup>
  );
};
